import { render, staticRenderFns } from "./cottonPic.vue?vue&type=template&id=d886529c&scoped=true&"
import script from "./cottonPic.vue?vue&type=script&lang=js&"
export * from "./cottonPic.vue?vue&type=script&lang=js&"
import style0 from "./cottonPic.vue?vue&type=style&index=0&id=d886529c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d886529c",
  null
  
)

export default component.exports